import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return (
    <SettingsMetaData propertyName={"VehicleStatus"} viewPropertyName={"Vehicle Status"}/>
  );
};

export default Status;
